{
  "addAdvisor": "Legg til rådgiver",
  "addBoardMember": "Legg til styremedlem",
  "addClusterManagement": "Legg til i ledelsen",
  "addContact": "Legg til kontakt",
  "addContacts": "Legg til kontakter",
  "addContingent": "Legg til kontigent",
  "addFocusArea": "Legg til fokusområde",
  "addHourRate": "Legg til timesats",
  "addInterestArea": "Legg til interesseområde",
  "addLead": "Legg til lead",
  "addLeaders": "Legg til ledelse",
  "addMainGoal": "Legg til hovedmål",
  "addCustomer": "Legg til kunde",
  "addPartner": "Legg til samarbeidspartner",
  "addProjectCategory": "Legg til prosjektkategori",
  "addSelfEffort": "Legg til egeninnsats",
  "approveSelfEffort": "Godkjenn egeninnsats",
  "brregFetch": "Hent fra BrReg",
  "cancel": "Avbryt",
  "createNewApplication": "Opprett ny søknad",
  "createProject": "Opprett prosjekt",
  "deleteInterestArea": "Slett interesseområde",
  "deleteSelfEffort": "Slett egeninnsats",
  "edit": "Redigere",
  "editFocusArea": "Endre fokusområde",
  "errorBoundaryResetButton": "Fjern feilmelding",
  "goToProjects": "Gå til Prosjekter",
  "gotoResourceBase": "Gå til ressursbasen",
  "import": "Import",
  "inviteToClusterPortal": "Inviter til portalen",
  "newEvent": "Nytt event",
  "newInterestArea": "Nytt interesseområde",
  "registerSelfEffort": "Registrer egeninnsats",
  "removeAdvisor": "Fjern fra rådgivere",
  "removeBoardMember": "Fjern fra styret",
  "removeContact": "Fjern kontakt",
  "removeManagement": "Fjern fra ledelse",
  "removeMarkings": "Fjern markeringer",
  "removeParticipant": "Fjern deltager",
  "save": "Lagre",
  "seeAllContacts": "Se alle kontakter",
  "seeAllMembers": "Se alle medlemmer",
  "sendReports": "Send inn rapporter",
  "unretire": "Meld inn",
  "clearFilter": "Nullstill filtre",
  "addOpportunity": "Legg til henvendelse",
  "importInvoice": "Importer faktura"
}
